import * as Yup from 'yup'

import { UserValidation, UserWarning, Warning } from '@const/translations'
import { phoneRegexp } from '@const/validation'
import { checkValidityPhoneNumber } from '@utils/utils'

export default Yup.object().shape({
  phone: Yup.string()
    .required(Warning.required)
    .nullable()
    .matches(phoneRegexp, UserValidation.phone)
    .test(
      'phone',
      UserWarning.invalidPhoneNumber,
      (value): boolean =>
        value ? checkValidityPhoneNumber(value) : true
    ),
  code: Yup.string()
    .nullable()
    .required(Warning.required)
})
